import React from "react";

import "./buttons.scss";

export default function Buttons() {
  return (
    <div className="container">
      <button className="button active">Summary</button>
      {/* <button className="button">Champions</button>
      <button className="button">Leagues</button>
      <button className="button live__game">
        <span>
          <i className="fab fa-searchengin"></i> Live Game
        </span>
      </button> */}
    </div>
  );
}
